import { CADRMSReportValueType } from '../../../../../Models/CadReportValue';

/**
 * Extracts the full address string from a CAD/RMS report location.
 */
export const getCADLocation = (
  report: CADRMSReportValueType
): string | undefined => {
  const locationId = report.cad.location?.address_id;
  const location = report.addresses.find(
    (address) => address.id === locationId
  );
  return location?.full || '';
};
